module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/LS-732b0fc452ac044866f0b0804393ed9f.png";